import { updateDraftPost } from '@wix/ambassador-blog-v3-draft/http';
import { createAction, type CommonThunkAction } from '@wix/communities-blog-client-common';
import { normalizePost } from '../services/post-utils';
import { getCategoryIds } from '../store/categories/categories-selectors';

export const UPDATE_POST_SUCCESS = 'post/DRAFT_UPDATE_SUCCESS';

const updatePostRequest = createAction('post/DRAFT_UPDATE_REQUEST');
const updatePostSuccess = createAction(UPDATE_POST_SUCCESS);
const updatePostFailure = createAction('post/DRAFT_UPDATE_FAILURE');

const getLatestSlug = (slugs: string[] | undefined) => {
  if (!slugs) {
    throw new Error('Slugs are undefined');
  }
  return slugs[slugs.length - 1];
};

export const updatePost = (post: any): CommonThunkAction => {
  return async (dispatch, getState, { httpClient, errorHandler }) => {
    dispatch(updatePostRequest());

    const state = getState();
    const { withErrorHandler, getResolvedError } = errorHandler;

    const updatePostPromise = withErrorHandler(
      () =>
        httpClient.request(updateDraftPost({ draftPost: post })).then(({ data }) => {
          const draftPost = data?.draftPost;

          if (!draftPost) {
            throw new Error('Post is undefined');
          }

          return {
            ...draftPost,
            slug: getLatestSlug(draftPost.slugs),
          };
        }),
      { errorCodesMap: {} },
    );

    try {
      const updatedPost = await updatePostPromise;
      dispatch(
        updatePostSuccess(
          normalizePost({
            state,
            post: updatedPost,
            blogCategoryIds: getCategoryIds(getState()),
          }),
        ),
      );
    } catch (error) {
      getResolvedError(error);
      dispatch(updatePostFailure());
    }

    return updatePostPromise;
  };
};
